import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Card, Button, Layout } from "antd";
import { AnimatePresence, motion } from "framer-motion";
import "./HomepageServices.scss";
import Slider from "react-slick"
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ModelViewer from "../../landingPage/sectionTwo/modelViewer";
import useSlickAccessibility from "../../../useSlickAccessibility";
const { Content } = Layout;

const services = [
    '3D model player',
    'Product images',
    'Lifestyle images',
    'AI images',
    'AR view in room',
    '3D configurator',
]

const services_dict = [
    {
        name: '3D model player',
        model: true,
        poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/38512_FrontAngled.jpg",
        src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/38512.glb",
        desc: 'Photorealistic 3D models including variants to use in ecommerce listings '
    },
    {
        name: 'Product images',
        img: 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/services-02-product-images-SM.jpg',
        mobile_img: 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/services-02-product-images-SM.jpg',
        alt: 'Product image examples on a neutral background',
        desc: 'Clear product shots in multiple angles on a white or gray background, with or without dimensions'
    },
    {
        name: 'Lifestyle images',
        img: 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/services-03-lifestyle-images-SM.jpg',
        mobile_img: 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/services-03-lifestyle-images-SM.jpg',
        alt: 'Lifestyle image examples showing products in a room scene',
        desc: 'Custom photorealistic images of your product set in a room scene'
    },
    {
        name: 'AI images',
        img: 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/services-04-AI-images.jpg',
        mobile_img: 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/services-04-AI-images-SM.jpg',
        alt: 'AI-generated product image examples',
        desc: 'Real-time images created from a single photo and a descriptive prompt'
    },
    {
        name: 'AR view in room',
        img: 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/services-04-AR-SM.jpg',
        mobile_img: 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/services-04-AR-SM.jpg',
        alt: 'AR view in room preview',
        desc: 'Uses an AR model to allow the View in Room feature'
    },
    {
        name: '3D configurator',
        img: 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/sectional.gif',
        mobile_img: 'https://d48f7equ64qjl.cloudfront.net/static_files/homepage_assets/sectional.gif',
        alt: '3D configurator preview showing product customization',
        desc: 'Infinite product customization controlled by the customer'
    },

]

const HomepageServices = () => {
    return (
        <>
            <WebVersion />
            <MobileVersion />
        </>
    )

}

const WebVersion = () => {
    const [selectedService, setSelectedServices] = useState('3D model player');
    return (
        <Content className="d-none d-lg-block">
            <Row className="container-fluid homepage-services-wrapper">
                <Col span={24} className="direction-flex coll justify-in-center">
                    <div className="manrope f-50 w-600 lh-60 mb-16 black-085 text-center">
                        Everything you need to sell your products
                        <div className="manrope f-50 w-600 lh-60 mb-20 blue text-center">without lifting a camera</div>
                    </div>

                    <div className="manrope f-16 w-500 lh-24 mb-40 black-085 text-center">Sell more, faster — with a 3D product library to create high-quality assets at anytime without costly reshoots.</div>

                </Col>
                <Col span={24} className="justify-in-center direction-flex roww button-gap mb-40">
                    {services.map((service, index) => (
                        <Button onClick={() => setSelectedServices(service)}
                            className={`manrope f-16 w-500 lh-24 ${selectedService == service ? `dark-white-blue-btn-selected` : `dark-white-blue-btn`}`}>
                            {service}
                        </Button>
                    ))}
                </Col>
                <Col span={24}>
                    {services_dict.map((service) => (
                        <>
                            {selectedService == service.name ?
                                <div className={`img-container`}>
                                    <AnimatePresence mode="wait">
                                        <motion.div
                                            key={selectedService}
                                            initial={{ y: 10, opacity: 0 }}
                                            animate={{ y: 0, opacity: 1 }}
                                            exit={{ y: -10, opacity: 0 }}
                                            transition={{ duration: 0.4 }}
                                        >
                                            {service.model ?
                                                <ModelViewer class='img-model'
                                                    poster={service.poster}
                                                    src={service.src} />
                                                :
                                                <img
                                                    src={service.img}
                                                    className={`img-dim ${service.name == '3D configurator' ? `center`: ``}`}
                                                    alt={service.alt}
                                                />}
                                        </motion.div>
                                    </AnimatePresence>
                                </div>
                                : ''}
                            {selectedService == service.name ?
                                <p className="manrope f-20 w-500 lh-28 black-085 mb-0 text-center mt-57">{service.desc}</p> : ''}
                        </>
                    ))}
                </Col>
            </Row>
        </Content>

    )
}

const MobileVersion = () => {
    const sliderContainerRef = useRef(null);
    let sliderRef = useRef(null);

    useSlickAccessibility(sliderContainerRef);

    const settings = {
        autoplay: false,
        dots: true,
        infinite: true,
        arrows: false,
        speed: 600,
        slidesToShow: 1.01,
        slidesToScroll: 1,
        vertical: false,
        customPaging: i => (
            <div className="custom-dot">
                {/* &ndash;  This is the dash */}
            </div>
        ),
    };

    return (
        <Content className="d-lg-none">
            <Row className="container-fluid homepage-services-wrapper">
                <Col span={24} className="direction-flex coll justify-in-center pdlr-16">
                    <div className="manrope f-38 w-600 lh-46 mb-16 black-085 text-left">
                        Everything you need to sell your products
                        <span className="manrope f-38 w-600 lh-46 blue">{" "}without lifting a camera</span>
                    </div>
                    <div className="manrope f-16 w-500 lh-24 mb-40 black-085 text-left">Sell more, faster—with a 3D product library to create high-quality assets at anytime without costly reshoots.</div>
                </Col>
                <Col span={24}>
                    <div ref={sliderContainerRef}>
                    <Slider ref={slider => {
                        sliderRef = slider;
                    }} {...settings} className="services-slider-setting">
                        {services_dict.map((service) => (
                            <Card className="services-card-wrapper" key={service.name} bordered={false}>
                                <Button className={`absolute-position manrope f-14 w-540 lh-22 dark-white-blue-btn-selected pd-small`}>
                                    {service.name}
                                </Button>
                                <Card className="services-card" bordered={true}>
                                    {service.model ?
                                        <div className="services-model-container">
                                            <ModelViewer class='services-model'
                                                poster={service.poster}
                                                src={service.src}
                                            />
                                        </div> :
                                        <img loading="lazy" src={service.mobile_img} className={`services-img-dim`} alt={service.alt} />}
                                </Card>
                                <p className="manrope f-14 w-500 lh-22 black-085 mb-0 mt-16">{service.desc}</p>
                            </Card>
                        ))}
                    </Slider>
                    </div>
                </Col>
            </Row>
        </Content>
    )
}

export default HomepageServices;
